import api from './api';

// 规则配置接口
export interface RuleConfig {
  id?: number;
  user_id?: number;
  client_id?: number;
  rule_config?: any;
  created_at?: string;
  updated_at?: string;
}

// 更新规则请求接口
export interface UpdateRuleRequest {
  id?: number;        // 规则ID（可选）
  name?: string;
  rule_config?: any;
}

// 创建规则请求接口
export interface CreateRuleRequest {
  name?: string;
  rule_config?: any;
}

export interface RuleListItem {
  id: number;
  user_id?: number;
  client_id?: number;
  name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface RuleListResponse {
  list: RuleListItem[];
  total: number;
}

// 规则服务
export const ruleService = {
  // 获取规则下拉（共享+我的），支持分页
  getRuleSelectList: async (params?: { page?: number; limit?: number; search?: string }): Promise<{
    shared: any[]; 
    mine: any[]; 
    total: number; 
    has_more: boolean;
    page: number;
    limit: number;
  }> => {
    const response = await api.post('/api/rules/select-list', params || {});
    const data = response.data.data || {};
    return { 
      shared: data.shared || [], 
      mine: data.mine || [],
      total: data.total || 0,
      has_more: data.has_more || false,
      page: data.page || 1,
      limit: data.limit || 50,
    };
  },
  // 获取链接的规则配置
  getRulesByLinkId: async (linkId: number): Promise<RuleConfig[]> => {
    const response = await api.post('/api/rules/link', { link_id: linkId });
    return response.data.data.list || [];
  },

  // 规则表列表（不依赖 link 信息）
  listAllRules: async (params?: any): Promise<RuleListResponse> => {
    const response = await api.post('/api/rules/list-all', params || {});
    const data = response.data?.data || { list: [], total: 0 };
    return { list: data.list || [], total: data.total || 0 };
  },

  // 创建规则配置
  createRule: async (data: CreateRuleRequest): Promise<RuleConfig> => {
    const response = await api.post('/api/rules/create', data);
    return response.data.data;
  },

  // 更新规则配置
  updateRule: async (data: UpdateRuleRequest): Promise<void> => {
    await api.post('/api/rules/update', data);
  },

  // 切换规则状态
  toggleRuleStatus: async (id: number, isActive: boolean): Promise<void> => {
    await api.post('/api/rules/toggle', { id, is_active: isActive });
  },

  // 获取规则详情
  getRuleDetail: async (id: number): Promise<RuleConfig> => {
    const response = await api.post('/api/rules/detail', { id });
    return response.data.data;
  },


}; 